/**
 * Meta Pixel — wrapper de PageView para navegações SPA.
 *
 * Escopo atual:
 *   - SÓ PageView. O `Lead` (e quaisquer outras conversões) é
 *     disparado por uma integração externa, fora deste repositório.
 *   - O base code do Pixel (init + PageView inicial) vive em
 *     index.html. Aqui apenas replicamos o PageView a cada mudança
 *     de rota porque o app é uma SPA e o Pixel não detecta isso
 *     sozinho.
 *
 * Pixel ID: gerenciado em `src/constants/analytics.js` (META_PIXEL_ID).
 */

const isFbqReady = () => typeof window !== 'undefined' && typeof window.fbq === 'function'

/**
 * Dispara um `PageView` após uma navegação SPA. Chamado a partir do
 * router.afterEach. Não envia parâmetros extras — o Pixel resolve
 * URL e referrer automaticamente.
 */
export const trackPageView = () => {
  if (!isFbqReady()) return
  try {
    window.fbq('track', 'PageView')
  } catch (e) {
    if (import.meta.env?.DEV) console.warn('[metaPixel] erro em PageView:', e)
  }
}
